/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureUnassignedNetworkInterfaces200Response {
  /**
  * The list of network interfaces
  */
  'networkInterfaces': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networkInterfaces",
      "baseName": "networkInterfaces",
      "type": "Array<string>",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return ListAzureUnassignedNetworkInterfaces200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

